import "./HVACServices.module.css";
import Header from "@/reusable_sections/Header";
import HeroHvacAtlanta from "./sections/HeroHvacAtlanta";
import Servicehighlights from "./sections/Servicehighlights";
import ServicePricingTable from "./sections/ServicePricingTable";
import HvacGuideContent from "./sections/HvacGuideContent";
import ExpertTechnicians from "./sections/ExpertTechnicians";
import Testimonials from "./sections/Testimonials";
import HvacFaq from "./sections/HvacFaq";
import ScheduleReadyCTA from "./sections/ScheduleReadyCTA";
import Booking from "./sections/Booking";
import Footer from "@/reusable_sections/Footer";
export default function HVACServicesPage() {
  return <div>
      <Header />
      <HeroHvacAtlanta />
      <Servicehighlights />
      <ServicePricingTable />
      <HvacGuideContent />
      <ExpertTechnicians />
      <Testimonials />
      <HvacFaq />
      <ScheduleReadyCTA />
      <Booking />
      <Footer />
    </div>;
}